export enum AdminInvoiceListItemAction {
  Download,
  SendToKsef,
  Synchronize,
}
